import React from "react";
import ProductCard from "./product_card";

const Promotion = () => {
  const products = [
    {
      name: "Windows POS",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F1674033810642df5a258e7dac100484e3c63e10728304?alt=media&token=ed8ccb4c-8a62-472b-b17c-e4a3d473e452",
      link: "https://nextgadgetshop.com/product/clauswmp68287401s68wcziu47",
    },
    {
      name: "Power Bank",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F16722898540061008ea38db87cb7d2eb597c1ce948161?alt=media&token=8562a77b-f31c-43d1-bee4-07a04635370f",
      link: "https://nextgadgetshop.com/product/clc8m8qpf16336501s6u209j6gf",
    },
    {
      name: "Thermal Printer",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F1669384047320c6c24711faf2e049a77c97bba4ce2fae?alt=media&token=1162b7ee-f612-4665-b60e-4604573a6744",
      link: "https://nextgadgetshop.com/product/clawk7xds13580501s683xq1frl",
    },
    {
      name: "Phone Cover",
      image:
        "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fnext%2Fitems%2F1671970149467e68b1dd2848e87cc132bc732b19b8695?alt=media&token=093032fa-0891-405c-874a-e342af1f12e2",
      link: "https://nextgadgetshop.com/product/clcbjzlbj7086401s67v37nozo",
    },

  ];


  return (
    <div className="pt-10">
      <h1 className="text-4xl text-gray-700 font-bold text-center">Promotions</h1>
      <div className="flex justify-center items-center gap-5 flex-wrap my-10">
        {products?.map((item, i) => (
          <a href={item.link}>
            <ProductCard key={i} item={item} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default Promotion;
